import React from 'react'

const SarasWrapper = (props) => {
    //this should be default format for reading props for all form controls
    const {customWrapper, wrapperStyle, wrapperClass, children} = props;

    if(customWrapper)
    {
        let CustomWrapper = customWrapper;

        return (
            <CustomWrapper style={wrapperStyle ? wrapperStyle : {}} className={wrapperClass}>
                {children}
            </CustomWrapper>
        )
    }
    else{
        return (<>
            {children}
        </>)
    }
}

export default SarasWrapper;
